import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Table from "@/components/TablePaginated.vue";
import { computed, ref, onMounted } from "vue";
import { HistoryModule } from "@/store/modules/History";
import { CallDataModule } from "@/store/modules/CallData";
import TicketHistory from "./TicketsHistory.vue";
import {
	TypificationModalModule,
	actionType,
} from "@/store/modules/TypificationModal";
import { AuthModule } from "@/store/modules/Auth";
import { env } from "@/config";
import { TableColumnCtx } from "element-plus";
import { IColumn } from "@/types/components";
import typificationHistoryModal from "./typificationHistoryModal.vue";
import AddMeetModal from "@/views/Meet/AddMeet.vue";

import { savedType } from "@/types/call";
// eslint-disable-next-line vue/no-setup-props-destructure
export interface IPagination {
	page?: number;
	limit?: number;
	filter?: string;
	sendNumber?: boolean;
	agentCode?: string;
	today?: boolean;
	onlyOutCalls?: boolean;
	type?: savedType;
	exitsData?: boolean;
}
interface IModalInfo {
	show?: boolean;
	agent_group?: string | null;
	column?: IColumn;
	showAdd?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    isMeetType: { type: Boolean }
  },
  setup(__props: any) {

const { isMeetType = false } = __props as { isMeetType?: boolean }

//-> Imports


//-> Types
let showOpts = ref(false);
// ===> Const
const itemValues = [
	{ value: "Mi_historial", label: "Mi historial" },
	{ value: "Buscador", label: "Buscador" },
];
const activeName = ref("first");
const modal = ref<IModalInfo>({
	show: false,
	agent_group: "",
	column: undefined,
	showAdd: false,
});

// ==> Let
let timer: ReturnType<typeof setTimeout>;

// ===> Computed
const History = computed(() => {
	return (HistoryModule.HistoryUser ? HistoryModule.HistoryUser : {}) as any;
});
const user = computed(() => AuthModule.user);
const loading = computed(() => {
	return HistoryModule.Loading;
});
// ===> Methods
function onEditClient(row: any) {
	const data = row.rawData;
	TypificationModalModule.setData(data);
	TypificationModalModule.setIdSql(row.id);
	TypificationModalModule.setIdMongo(row._id);
	TypificationModalModule.setType(actionType.edit);
	CallDataModule.setScore(true);
	CallDataModule.getCallCenterClient(row.Numero);
	CallDataModule.setActiveCall({
		call_number: row.Numero,
		uniqueid: "",
		call_status: undefined,
		resultado: 0,
		call_type: row.Tipo,
		queue: row.queue,
		id: row._id,
	});
}
function callback(pag: IPagination, select = "") {
	showOpts.value = true;
	pag.type = isMeetType ? savedType.meet : undefined;
	pag.exitsData = isMeetType ? false : true;
	if (select != "" && select == itemValues[1].value) {
		showOpts.value = false;
		pag.agentCode = "";
		pag.today = false;
		pag.onlyOutCalls = env.onlyOutCallsGlobalCallHistory;
	}

	pag != undefined
		? HistoryModule.updateUserHistory(pag)
		: HistoryModule.updateUserHistory(undefined);
}
function callInputback(pag: IPagination, select = "") {
	clearTimeout(timer); // Reiniciar el temporizador
	timer = setTimeout(function () {
		callback(pag, select);
	}, 500);
}
const handleClick = () => {
	HistoryModule.setHistoryUser(undefined);
};
async function onRowClick({
	row: rowValue,
}: {
	row: IColumn;
	col: TableColumnCtx<any>;
	e: PointerEvent;
}) {
	modal.value.show = true;
	modal.value.column = rowValue ?? undefined;
	modal.value.agent_group = rowValue?.agent_group ?? null;
}
const changeModal = ({ show }: { show: boolean }) => {
	modal.value.show = show;
};
async function onBtnAction() {
	modal.value.showAdd = true;
}
onMounted(() => {
	if (isMeetType) activeName.value = "four";
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeName).value = $event)),
      type: "card",
      class: "shadow-sm p-3",
      onTabClick: handleClick
    }, {
      default: _withCtx(() => [
        (!__props.isMeetType)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "Calificación de llamadas",
              name: "first"
            }, {
              default: _withCtx(() => [
                _createVNode(Table, {
                  onUpdateData: _cache[0] || (_cache[0] = (payload) => {
					callback({ ...payload.pagination, sendNumber: true });
				}
				),
                  onUpdateInputData: _cache[1] || (_cache[1] = (payload) => {
					callInputback({ ...payload.pagination, sendNumber: true });
				}
				),
                  tableData: _unref(History),
                  load: _unref(loading),
                  tittle: "Calificación de llamada",
                  tittlebtn: "Actualizar",
                  disabled: !_unref(CallDataModule).scoring,
                  btn: true,
                  filter: true,
                  tableLayout: "fixed",
                  cardClass: "m-1",
                  information: true,
                  informationLabel: "Se puede buscar por <ul>\n\t\t\t\t\t\t\t\t<li>Tipo</li>\n\t\t\t\t\t\t\t\t<li>Cola</li>\n\t\t\t\t\t\t\t\t<li>Cliente</li>\n\t\t\t\t\t\t\t\t<li>Número</li>\n\t\t\t\t\t\t\t\t<li>Agente</li>\n\t\t\t\t\t\t\t\t</ul>",
                  onRowClick: onRowClick
                }, null, 8, ["tableData", "load", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!__props.isMeetType)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "Calificación Global",
              name: "second"
            }, {
              default: _withCtx(() => [
                _createVNode(Table, {
                  onEdit: onEditClient,
                  onUpdateData: _cache[2] || (_cache[2] = (payload) => {
					callback({
						...payload.pagination,
						sendNumber: false,
						agentCode: _unref(user)?.code ?? '',
						today: true,
					}, payload.typeSelect);
				}
				),
                  onUpdateInputData: _cache[3] || (_cache[3] = (payload) => {
					callInputback({ ...payload.pagination, sendNumber: false, agentCode: _unref(user)?.code ?? '', today: true }, payload.typeSelect);
				}
				),
                  tableData: _unref(History),
                  load: _unref(loading),
                  tittle: "Calificación Global",
                  tittlebtn: "Actualizar",
                  disabled: false,
                  btn: true,
                  filter: true,
                  "show-options": _unref(showOpts) && _unref(env).DynamicTypification,
                  cardClass: "m-1",
                  tableLayout: "fixed",
                  select: true,
                  selectArray: itemValues,
                  defaultSelect: itemValues[0].value,
                  information: true,
                  informationLabel: "Se puede buscar por <ul>\n\t\t\t\t\t\t\t\t<li>Tipo</li>\n\t\t\t\t\t\t\t\t<li>Cola</li>\n\t\t\t\t\t\t\t\t<li>Cliente</li>\n\t\t\t\t\t\t\t\t<li>Número</li>\n\t\t\t\t\t\t\t\t<li>Agente</li>\n\t\t\t\t\t\t\t\t</ul>"
                }, null, 8, ["tableData", "load", "show-options", "defaultSelect"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
				_unref(env).requiredCallcenter &&
					!_unref(env).onlyCallcenter &&
					_unref(CallDataModule).user?._id &&
					!__props.isMeetType
			)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "Historial de tickets",
              name: "third"
            }, {
              default: _withCtx(() => [
                _createVNode(TicketHistory)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.isMeetType)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 3,
              label: "Reuniones",
              name: "four"
            }, {
              default: _withCtx(() => [
                _createVNode(Table, {
                  onUpdateData: _cache[4] || (_cache[4] = (payload) => {
					callback({ ...payload.pagination });
				}
				),
                  onUpdateInputData: _cache[5] || (_cache[5] = (payload) => {
					callInputback({ ...payload.pagination });
				}
				),
                  tableData: _unref(History),
                  load: _unref(loading),
                  tittle: "Reuniones",
                  tittlebtn: "Actualizar",
                  disabled: false,
                  btn: true,
                  btn2: true,
                  btn2Title: "Agregar reunión",
                  filter: true,
                  tableLayout: "fixed",
                  cardClass: "m-1",
                  onRowClick: onRowClick,
                  onBtnAction: onBtnAction
                }, null, 8, ["tableData", "load"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(typificationHistoryModal, {
      show: modal.value.show,
      agent_group: modal.value.agent_group,
      column: modal.value.column,
      onChangeModal: _cache[7] || (_cache[7] = s => changeModal(s)),
      isMeetType: __props.isMeetType
    }, null, 8, ["show", "agent_group", "column", "isMeetType"]),
    _createVNode(AddMeetModal, {
      show: modal.value.showAdd,
      agent_group: modal.value.agent_group,
      column: modal.value.column,
      onChangeModal: _cache[8] || (_cache[8] = s => (modal.value.showAdd = s.show)),
      onUpdateCallBack: _cache[9] || (_cache[9] = ($event: any) => (callback({})))
    }, null, 8, ["show", "agent_group", "column"])
  ], 64))
}
}

})